/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {APP_BASE_HREF} from '@angular/common';
import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatFormFieldModule, MatNativeDateModule } from "@angular/material";
import {MatDatepickerModule} from '@angular/material';
import {MatInputModule} from '@angular/material/input';
import {NgModule} from '@angular/core';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import { NbAuthJWTToken, NbTokenService, NbAuthService } from '@nebular/auth';
import { NbThemeModule } from '@nebular/theme';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ThemeModule} from './@theme/theme.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NbAuthModule, NbPasswordAuthStrategy} from '@nebular/auth';
import {BrowserXhr} from '@angular/http';
import {CustExtBrowserXhr} from './@core/cust-ext-browser-xhr';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import {DndModule} from 'ng2-dnd';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AUTH_CONFIG, AUTH_CONFIG_API} from './configs/auth.config';

import {AdminRouteGuard} from './admin-route-guard';
import {UserRouteGuard} from './user-route-guard';
import {ManagerRouteGuard} from './manager-route-guard';
import {RedirectComponent} from './redirect/redirect.component';
import { ActionService } from './@core/data/action.service';
import { ProjectsService } from './@core/data/projects.service';
import { PolygonService } from './@core/data/polygon.service';
import { UsersService } from './@core/data/users.service';
import { DataService } from './services/data.service';
import { GroupPolygonService } from './@core/data/group-polygon.service';
import { CatStatusCheckService } from './@core/data/cat-status-check.service';

import { NB_AUTH_OPTIONS } from '@nebular/auth';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'https://server.globesensing.com/api/v1/translations/');
}

@NgModule({
  declarations: [
    AppComponent,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    LeafletModule.forRoot(),
    LeafletDrawModule.forRoot(),
    DndModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NbAuthModule.forRoot(AUTH_CONFIG),
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: BrowserXhr, useClass: CustExtBrowserXhr},
    {provide: APP_BASE_HREF, useValue: '/'},
    AdminRouteGuard,
    ManagerRouteGuard,
    UserRouteGuard,
    Title,
    ActionService,
    ProjectsService,
    PolygonService,
    UsersService,
    DataService,
    GroupPolygonService,
    CatStatusCheckService,
    NbAuthService,
    NbTokenService,
    NbThemeModule.forRoot().providers,
  ],
  exports: [TranslateModule],
})
export class AppModule {
  constructor(
    authService: NbAuthService, // force construction of the auth service
    authStrategy: NbPasswordAuthStrategy
  ) {
    authStrategy.setOptions({
      name: 'email',
      token: {
        class: NbAuthJWTToken,
        key: 'token',
      },
      ...AUTH_CONFIG_API
    });
  }
}
